import { isValidIBANNumber } from 'Components/ContractGenerator/shared/helpers/validationHelpers';

const validate = (value, name, label, t, required, formName, showErrorMessage = true) => {
	const errorMessages = [];

	if (required && (typeof value === 'undefined' || value === '')) {
		errorMessages.push(t('pages.step2.contractData.form.errorMessages.cantBeEmpty'));
	}

	if (errorMessages.length === 0 && typeof value !== 'undefined' && value !== '') {
		if ((name === 'fax' || name === 'phone') && !value.match(/^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s./0-9]*$/g)) {
			errorMessages.push(t('pages.step2.contractData.form.errorMessages.notAPhoneNumber'));
		}

		if (
			name === 'email' &&
			!value
				.toLowerCase()
				.match(/^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i)
		) {
			errorMessages.push(t('pages.step2.contractData.form.errorMessages.notAEmailAddress'));
		}

		if (
			name === 'website' &&
			!value.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g)
		) {
			errorMessages.push(t('pages.step2.contractData.form.errorMessages.notAWebsite'));
		}

		if (name === 'iban' && isValidIBANNumber(value) !== 1) {
			errorMessages.push(t('pages.step2.contractData.form.errorMessages.notAIban'));
		}

		if (
			name === 'bic' &&
			!value.match(
				/^[A-Z]{4}(AC|AD|AE|AF|AG|AI|AL|AM|AN|AO|AQ|AR|AS|AT|AU|AW|AX|AZ|BA|BB|BD|BE|BF|BG|BH|BI|BJ|BL|BM|BN|BO|BQ|BR|BS|BT|BV|BW|BY|BZ|CA|CC|CD|CE|CF|CG|CH|CI|CK|CL|CM|CN|CO|CP|CR|CS|CU|CV|CW|CX|CY|CZ|DD|DE|DG|DJ|DK|DM|DO|DZ|EA|EC|EE|EG|EH|ER|ES|ET|EU|FI|FJ|FK|FM|FO|FR|FX|GA|GB|GD|GE|GF|GG|GH|GI|GL|GM|GN|GP|GQ|GR|GS|GT|GU|GW|GY|HK|HM|HN|HR|HT|HU|IC|ID|IE|IL|IM|IN|IO|IQ|IR|IS|IT|JE|JM|JO|JP|KE|KG|KH|KI|KM|KN|KP|KR|KW|KY|KZ|LA|LB|LC|LI|LK|LR|LS|LT|LU|LV|LY|MA|MC|MD|ME|MF|MG|MH|MK|ML|MM|MN|MO|MP|MQ|MR|MS|MT|MU|MV|MW|MX|MY|MZ|NA|NC|NE|NF|NG|NI|NL|NO|NP|NR|NT|NU|NZ|OM|PA|PE|PF|PG|PH|PK|PL|PM|PN|PR|PS|PT|PW|PY|QA|RE|RO|RS|RU|RW|SA|SB|SC|SD|SE|SF|SG|SH|SI|SJ|SK|SL|SM|SN|SO|SR|SS|ST|SU|SV|SX|SY|SZ|TA|TC|TD|TF|TG|TH|TJ|TK|TL |TM|TN|TO|TP|TR|TT|TV|TW|TZ|UA|UG|UK|UM|US|UY|UZ|VA|VC|VE|VG|VI|VN|VU|WF|WS|XK|YE|YT|ZA|ZM|ZR|ZW)[2-9A-Z][0-9A-NP-Z](XXX|[0-9A-WYZ][0-9A-Z]{2})?$/i
			)
		) {
			errorMessages.push(t('pages.step2.contractData.form.errorMessages.notABic'));
		}
	}

	if (errorMessages.length > 0) {
		return {
			isValid: false,
			errorMessages,
			label,
			formName,
			showErrorMessage
		};
	}

	return {
		isValid: true
	};
};

export default validate;
